module.exports = __webpack_public_path__ + "media/error.3cb8561d.mp3";